export default class AddressAutoComplete {
    constructor(fieldSelectors) {
        // Use old selector keys for compatibility
        this.address1Field = document.querySelector(fieldSelectors.address1 || 'input[name="address[addressLine1]"]');
        this.address2Field = document.querySelector(fieldSelectors.shippingAddress || 'input[name="address[locality]"]');
        this.postalField = document.querySelector(fieldSelectors.zipcode || 'input[name="address[postalCode]"]');
        this.stateField = document.querySelector(fieldSelectors.state || 'select[name="address[administrativeArea]"]');
        this.countryField = document.querySelector(fieldSelectors.country || 'select[name="address[countryCode]"]');

        console.log('AddressAutoComplete.js loaded - version 8');

        if (this.address1Field) {
            this.initAutocomplete();
        } else {

        }
    }

    initAutocomplete() {
        this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
            componentRestrictions: { country: ["au"] },
            fields: ["address_components", "formatted_address"],
            types: ["address"],
        });

        this.autocomplete.addListener("place_changed", this.fillInAddress.bind(this));

        this.address1Field.addEventListener('change', () => {
            console.log('Address1 changed:', this.address1Field.value);
            const errorField = document.querySelector('.gm-err-autocomplete');
            if (errorField) {
                errorField.disabled = false;
                errorField.placeholder = '';
            }
        });

        this.address1Field.addEventListener('focus', () => {
            console.log('Address1 focused');
        });

        this.address1Field.addEventListener('blur', () => {
            console.log('Address1 blurred');
        });

        setTimeout(() => {
            this.address1Field.setAttribute('autocomplete', 'chrome-off');
        }, 200);
    }

    fillInAddress() {
        const place = this.autocomplete.getPlace();
        let postcode = "";
        let locality = "";
        let hasStreetNumber = false;
        let hasSubpremise = false;

        console.log('Raw address_components:', JSON.stringify(place.address_components));
        console.log('Formatted address:', place.formatted_address);

        // Use formatted_address for address1 to preserve "1/2 Broadway"
        let address1 = place.formatted_address.split(',')[0].trim();
        console.log('Extracted address1:', address1);

        // Process address components
        for (const component of place.address_components) {
            const componentType = component.types[0];

            switch (componentType) {
                case "subpremise": {
                    console.log('Subpremise:', component.long_name);
                    hasSubpremise = true;
                    break;
                }
                case "street_number": {
                    console.log('Street Number:', component.long_name);
                    hasStreetNumber = true;
                    break;
                }
                case "route": {
                    console.log('Route:', component.short_name);
                    break;
                }
                case "locality": {
                    locality = component.long_name;
                    console.log('Locality:', locality);
                    break;
                }
                case "postal_code": {
                    postcode = component.long_name;
                    console.log('Postcode:', postcode);
                    break;
                }
                case "postal_code_suffix": {
                    postcode = `${postcode}-${component.long_name}`;
                    console.log('Postcode with suffix:', postcode);
                    break;
                }
                case "administrative_area_level_1": {
                    if (this.stateField) {
                        this.stateField.querySelectorAll('option').forEach((option) => {
                            if (component.short_name === option.value) {
                                this.stateField.selectedIndex = option.index;
                                console.log('State set:', component.short_name);
                            }
                        });
                    }
                    break;
                }
                case "country": {
                    if (this.countryField) {
                        this.countryField.querySelectorAll('option').forEach((option) => {
                            if (component.short_name === option.value) {
                                this.countryField.selectedIndex = option.index;
                                console.log('Country set:', component.short_name);
                            }
                        });
                    }
                    break;
                }
            }
        }

        // Populate fields with null checks
        if (this.address1Field) {
            this.address1Field.value = address1;
            console.log('Address1 field set to:', this.address1Field.value);
        }
        if (this.address2Field) {
            this.address2Field.value = locality;
            console.log('Address2 (locality) field set to:', locality);
        }
        if (this.postalField) {
            this.postalField.value = postcode;
            console.log('Postal field set to:', postcode);
        }

        // Check if neither street number nor subpremise was found
        if (!hasStreetNumber && !hasSubpremise) {
            alert('The selected address does not contain a valid street number. Please manually update to correct.');

            // Create and append style element to hide pac-container
            const style = document.createElement('style');
            style.textContent = '.pac-container { display: none !important; }';
            document.head.appendChild(style);
            console.log('Google Places dropdown hidden via injected style');

            if (this.address1Field) {
                // Focus on address1Field for manual editing
                setTimeout(() => {
                    this.address1Field.focus();
                    console.log('Address1 focused for manual editing');
                }, 100);
            }
        } else {
            // Blur address1Field and focus address2Field (locality) if valid numerical component exists
            if (this.address1Field) {
                this.address1Field.blur();
                console.log('Address1 blurred after setting value');
            }
            if (this.address2Field) {
                setTimeout(() => {
                    this.address2Field.focus();
                    console.log('Address2 (locality) focused');
                }, 100);
            } else {
                console.warn('Address2 (locality) field not found, focus not moved');
            }
        }
    }
}